<header class="expense-panel__header">
  <div>
    <h2 class="expense-panel__title">
      {{ 'expenses.detail.title' | translate }}
    </h2>
    <p class="expense-panel__subtitle">
      {{ expense.orderHash }}
      <ng-container *ngIf="expense.reportedAt as reportedAt">
        &middot; {{ reportedAt | date : 'dd/MM/yy' }}
      </ng-container>
    </p>
  </div>

  <button
    type="button"
    class="expense-panel__close"
    [attr.aria-label]="'expenses.close' | translate"
    (click)="close()"
  >
    <tui-icon icon="tuiIconClose" [style.font-size.rem]="1.25"></tui-icon>
  </button>
</header>

<div class="expense-panel__body">
  <dl class="expense-detail__grid">
    <div class="expense-detail__field">
      <dt>{{ 'expenses.labels.driver' | translate }}</dt>
      <dd>{{ expense.driverName || ('expenses.no_value' | translate) }}</dd>
    </div>
    <div class="expense-detail__field">
      <dt>{{ 'expenses.labels.license_plate' | translate }}</dt>
      <dd>{{ expense.licensePlate || ('expenses.no_value' | translate) }}</dd>
    </div>
    <div class="expense-detail__field">
      <dt>{{ 'expenses.labels.category' | translate }}</dt>
      <dd>{{ expense.category | expenseCategoryLabel }}</dd>
    </div>
    <div class="expense-detail__field">
      <dt>{{ 'expenses.labels.amount' | translate }}</dt>
      <dd class="expense-detail__amount">
        {{ expense.amountInCents | expenseAmount : expense.currencyCode }}
      </dd>
    </div>

    <div class="expense-detail__field expense-detail__field--wide">
      <dt>{{ 'expenses.labels.status' | translate }}</dt>
      <dd>
        <app-expense-status-badge
          [status]="expense.status"
        ></app-expense-status-badge>
      </dd>
    </div>

    <div class="expense-detail__field expense-detail__field--wide">
      <dt>{{ 'expenses.labels.description' | translate }}</dt>
      <dd>{{ expense.description || ('expenses.no_value' | translate) }}</dd>
    </div>

    <!--
      Motivo de la devolución, traducido desde el código. Sale aparte del texto
      libre a propósito: son dos datos distintos y el gasto puede tener uno, el
      otro o los dos. Los devueltos antes del catálogo sólo llevan texto.
    -->
    <div
      *ngIf="returnReasonLabelKey as returnReasonKey"
      class="expense-detail__field expense-detail__field--wide"
    >
      <dt>{{ 'expenses.labels.return_reason' | translate }}</dt>
      <dd>{{ returnReasonKey | translate }}</dd>
    </div>

    <div
      *ngIf="expense.review?.rejectionReason as rejectionReason"
      class="expense-detail__field expense-detail__field--wide"
    >
      <dt>{{ 'expenses.labels.rejection_reason' | translate }}</dt>
      <dd>{{ rejectionReason }}</dd>
    </div>

    <div class="expense-detail__field expense-detail__field--wide">
      <dt>{{ 'expenses.labels.receipt' | translate }}</dt>
      <dd class="expense-detail__receipt">
        <img
          *ngIf="expense.receiptUrl; else noReceipt"
          class="expense-detail__receipt-image"
          [src]="expense.receiptUrl"
          [alt]="'expenses.receipt_attached' | translate"
        />

        <ng-template #noReceipt>
          <span class="expense-detail__receipt-empty">
            {{ 'expenses.review_modal.no_receipt' | translate }}
          </span>
        </ng-template>
      </dd>
    </div>
  </dl>
</div>

<footer class="expense-panel__footer expense-panel__footer--stacked">
  <button
    type="button"
    class="expense-panel__button expense-panel__button--primary"
    (click)="requestEdit()"
  >
    <tui-icon icon="tuiIconEdit2" [style.font-size.rem]="1"></tui-icon>
    {{ 'expenses.detail.edit' | translate }}
  </button>

  <!--
    Oculto cuando el panel se abre desde el propio detalle del servicio: allí el
    botón llevaría a la página en la que ya está el usuario.
  -->
  <button
    *ngIf="showServiceLink && canOpenService()"
    type="button"
    class="expense-panel__button expense-panel__button--secondary"
    [attr.title]="
      'expenses.open_service_aria' | translate : { order: expense.orderHash }
    "
    (click)="openService()"
  >
    <tui-icon icon="tuiIconExternalLink" [style.font-size.rem]="1"></tui-icon>
    {{ 'expenses.open_service' | translate }}
  </button>

  <button
    type="button"
    class="expense-panel__button expense-panel__button--ghost"
    (click)="close()"
  >
    {{ 'expenses.close' | translate }}
  </button>
</footer>
